import {FC, ReactNode, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import {useLocation, useParams} from 'react-router-dom';

import {CultureAnalysisPdfContext} from './CultureAnalysisPdfContext';
import {useCultureAnalysisPdfPage} from '../../pages/company/culture/CultureAnalysisPdfPage/useCultureAnalysisPdfPage';

export const CultureAnalysisPdfProvider: FC<{children: ReactNode}> = ({children}) => {
  const {resourceId = ''} = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const downloadToken = queryParams.get('download_token') as string;
  const language = queryParams.get('language') as string;

  const {i18n} = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [i18n, language]);

  const {data, loading, error} = useCultureAnalysisPdfPage(resourceId, downloadToken, language);

  return (
    <CultureAnalysisPdfContext.Provider value={{resourceId, downloadToken, language, data, loading, error}}>
      {children}
    </CultureAnalysisPdfContext.Provider>
  );
};
